import { IconButton as MuiIconButton } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const IconButton = styled(MuiIconButton)`
  cursor: default !important;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};
  display: flex;
  width: 48px;
  height: 48px;
  padding: ${theme.spacing.xSmall}px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.sm}px;
  color: ${theme.colors.textSecondary};

  svg path {
    stroke: currentColor;
  }

  &:hover {
    background: ${theme.colors.legacy393038};
  }
`
